module.exports = __webpack_public_path__ + "a6d4b0df3b2027e453826e16c3d01c38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/chat-icon-white.svg
// module id = 364
// module chunks = 1